import { useAtom } from 'jotai/react'
import { useMemo, useState } from 'react'

import { MILLISECOND } from '@/constants/common'
import { METHOD } from '@/lib/fetcher'
import { addressAtom, fromChainIdAtom } from '@/stores/trade'

import { useFetch } from './useFetch'

export enum TRANSFER_STATUS {
  PENDING = 101, // 确认中
  SUCCESS = 102, // 交易成功
  FAILED = 103 // 交易失败
}

export type BaseTransferInfo = {
  from_chain_name: string //发送链名字
  from_chain_logo_url: string //发送链logo
  from_token_symbol: string //发送合约名字
  from_token_logo_url: string //发送合约logo
  from_token_ca_add: string //发送合约地址
  from_address: string //发送地址
  from_hash: string //发送合约哈希
  in_amount: string //发送金额
  in_time: string //发送时间
  to_chain_name: string //接收链名字
  to_chain_logo_url: string //接收链logo
  to_token_symbol: string //接收合约名字
  to_token_logo_url: string //接收合约logo
  to_token_ca_add: string //接收合约地址
  to_chain_hash: string //接收合约哈希
  to_address: string //接受地址
  out_amount: string //接受数量
  out_time: string //接收时间
  status: TRANSFER_STATUS //101   确认中  102  交易成功  103  交易失败
}

export type TransferInfo = {
  from: {
    address: string
    amount: string
    time: string
    hash: string
    chain: {
      name: string
      logo: string
    }
    token: {
      address: string
      logo: string
      symbol: string
    }
  }
  to: TransferInfo['from']
  status: TRANSFER_STATUS
}

export const useTransferInfo = () => {
  const [address] = useAtom(addressAtom)
  const [fromChainId] = useAtom(fromChainIdAtom)

  const [refreshInterval, setRefreshInterval] = useState<number>(MILLISECOND.SECOND_10)

  const { data } = useFetch<{
    data: BaseTransferInfo[]
  }>({
    method: METHOD.GET,
    // url: '/transferinfo',
    // data: {
    //   from_chain_id: 56,
    //   address: '0x652cf56cfed301085f4070d4ba1d2b47bae96228'
    // },
    url: fromChainId && address ? '/transferinfo' : null,
    data: {
      from_chain_id: fromChainId,
      address
    },
    options: {
      refreshInterval
      // onSuccess(data) {
      //   const hasPending = data.data.data.some(({ status }) => status === TRANSFER_STATUS.PENDING)
      //   setRefreshInterval(hasPending ? 10_000 : undefined)
      // }
    }
  })

  const transferInfos = useMemo(() => {
    if (!data || data.code !== 200 || !data.data) return []

    const { data: baseTransferInfos } = data.data

    const transferInfos = baseTransferInfos.map<TransferInfo>(
      ({
        from_address,
        from_chain_logo_url,
        from_chain_name,
        from_hash,
        from_token_ca_add,
        from_token_logo_url,
        from_token_symbol,
        in_amount,
        in_time,
        to_address,
        to_chain_hash,
        to_chain_logo_url,
        to_chain_name,
        to_token_ca_add,
        to_token_logo_url,
        to_token_symbol,
        out_amount,
        out_time,
        status
      }) => {
        return {
          from: {
            address: from_address,
            amount: in_amount,
            time: in_time,
            hash: from_hash,
            chain: {
              name: from_chain_name,
              logo: from_chain_logo_url
            },
            token: {
              address: from_token_ca_add,
              logo: from_token_logo_url,
              symbol: from_token_symbol
            }
          },
          to: {
            address: to_address,
            amount: out_amount,
            time: out_time,
            hash: to_chain_hash,
            chain: {
              name: to_chain_name,
              logo: to_chain_logo_url
            },
            token: {
              address: to_token_ca_add,
              logo: to_token_logo_url,
              symbol: to_token_symbol
            }
          },
          status
        }
      }
    )

    console.log('>>>>>> transferInfos: ', transferInfos)

    return transferInfos
  }, [data])

  return {
    transferInfos,
    setRefreshInterval
  }
}
